//#region lib/components/ImageGallery/types.ts
function e(e, t) {
	return Math.min(Math.max(e, 0), Math.max(0, t - 1));
}
function t(t, n, r, i) {
	let a = e(t, r), o = a + n;
	return o >= 0 && o < r ? o : i ? n === 1 ? 0 : r - 1 : a;
}
//#endregion
export { e as clampIndex, t as stepIndex };
